import {css} from 'styled-components';

export default css`
	.tooltip {
		position: absolute;
		display: block;
		font-style: normal;
		font-weight: 400;
		line-height: var(--px-20);
		line-break: auto;
		text-align: start;
		text-decoration: none;
		text-shadow: none;
		text-transform: none;
		letter-spacing: normal;
		word-break: normal;
		word-spacing: normal;
		word-wrap: normal;
		white-space: normal;
		filter: alpha(opacity=0);
		z-index: 99999999999 !important;

		&.tooltipCustomWidth {
			width: auto;
			max-width: 20%;
		}

		.tooltip-arrow {
			position: absolute;
			width: 0;
			height: 0;
			border-color: transparent;
			border-style: solid;
		}

		&.fade {
			transition: opacity 0.15s linear;
		}

		&.in {
			filter: alpha(opacity=100);
			opacity: 1;

			&.top {
				.tooltip-arrow {
					border-top-color: var(--neutrals-00white) !important;
				}
			}

			&.bottom {
				.tooltip-arrow {
					border-bottom-color: var(--neutrals-00white) !important;
				}
			}
		}

		&.top {
			padding: var(--px-10) 0;
			margin-top: calc(var(--px-3) * -1);

			.tooltip-arrow {
				bottom: 0;
				left: 50%;
				border-width: var(--px-10) var(--px-10) 0;
				border-top-color: var(--neutrals-00white) !important;
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
			}
		}

		&.bottom {
			padding: var(--px-10) 0;
			margin-top: var(--px-3);

			.tooltip-arrow {
				top: 0;
				left: 50%;
				margin-left: calc(var(--px-5) * -1);
				border-width: 0 var(--px-10) var(--px-10);
				border-bottom-color: var(--neutrals-00white) !important;
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
			}
		}

		.tooltip-inner {
			padding: var(--px-6);
			font-size: var(--px-14);
			color: var(--neutrals-1000) !important;
			background-color: var(--neutrals-00white) !important;
			box-shadow: 0 0 var(--px-20) 0 rgba(0, 0, 0, 0.3);
			text-align: left;
			word-wrap: break-word;
			border-radius: var(--px-4);
			max-width: var(--px-700);
		}
	}
`;
